import * as yup from 'yup'

export const AddCustomerJourneySchema = yup.object().shape({
    customer_journey_explaination: yup.object().shape({
        sale_tracking_id: yup.array().min(1, 'sale_tracking_id_empty'),
        service_interestings: yup.array().min(1, 'service_interestings_empty'),
    }),
})
